import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Tooltip,
  Avatar,
  Menu,
  MenuItem,
  ListItemIcon,
  Divider,
} from '@mui/material';
import {
  Menu as MenuIcon,
  DarkMode,
  LightMode,
  Logout,
  Person,
} from '@mui/icons-material';
import { toggleDarkMode, toggleMobileSidebar } from '../../store/slices/uiSlice';
import { logout } from '../../store/slices/authSlice';

const SIDEBAR_WIDTH = 260;

// 경로 → 페이지 제목 매핑
const pageTitles = {
  '/nkadmin/dashboard': '대시보드',
  '/nkadmin/consultations': '상담 관리',
  '/nkadmin/qa': 'Q&A 설정',
  '/nkadmin/bot': '봇 설정',
  '/nkadmin/site-settings': '사이트 설정',
  '/nkadmin/sms-settings': 'SMS 설정',
  '/nkadmin/security-logs': '보안 로그',
  '/nkadmin/users': '사용자 관리',
};

const TopBar = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { darkMode } = useSelector((state) => state.ui);
  const { userInfo } = useSelector((state) => state.auth);
  const [anchorEl, setAnchorEl] = React.useState(null);

  const pageTitle = pageTitles[location.pathname] || '관리자';

  const handleMenuOpen = (e) => setAnchorEl(e.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);

  const handleLogout = () => {
    handleMenuClose();
    dispatch(logout());
    navigate('/nklogin');
  };

  return (
    <AppBar
      position="fixed"
      elevation={0}
      sx={{
        width: { md: `calc(100% - ${SIDEBAR_WIDTH}px)` },
        ml: { md: `${SIDEBAR_WIDTH}px` },
        bgcolor: 'background.paper',
        color: 'text.primary',
        borderBottom: 1,
        borderColor: 'divider',
      }}
    >
      <Toolbar>
        {/* 모바일 햄버거 */}
        <IconButton
          edge="start"
          onClick={() => dispatch(toggleMobileSidebar())}
          sx={{ mr: 2, display: { md: 'none' } }}
        >
          <MenuIcon />
        </IconButton>

        {/* 페이지 제목 */}
        <Typography variant="h6" noWrap sx={{ flexGrow: 1, fontWeight: 600 }}>
          {pageTitle}
        </Typography>

        {/* 다크모드 토글 */}
        <Tooltip title={darkMode ? '라이트 모드' : '다크 모드'}>
          <IconButton onClick={() => dispatch(toggleDarkMode())} sx={{ mr: 1 }}>
            {darkMode ? <LightMode /> : <DarkMode />}
          </IconButton>
        </Tooltip>

        {/* 사용자 메뉴 */}
        <Tooltip title="계정">
          <IconButton onClick={handleMenuOpen} sx={{ p: 0.5 }}>
            <Avatar sx={{ width: 32, height: 32, bgcolor: 'primary.main', fontSize: 14 }}>
              {userInfo?.username?.[0]?.toUpperCase() || 'A'}
            </Avatar>
          </IconButton>
        </Tooltip>

        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
          transformOrigin={{ horizontal: 'right', vertical: 'top' }}
          anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        >
          <MenuItem disabled>
            <ListItemIcon><Person fontSize="small" /></ListItemIcon>
            {userInfo?.username || '관리자'}
          </MenuItem>
          <Divider />
          <MenuItem onClick={handleLogout}>
            <ListItemIcon><Logout fontSize="small" /></ListItemIcon>
            로그아웃
          </MenuItem>
        </Menu>
      </Toolbar>
    </AppBar>
  );
};

export default TopBar;
